// Site content and look, in one place.
//
// This replaces the Claude Design Tweaks panel, which only ever rendered
// inside the Design host (it opens on a postMessage the host sends and a
// deployed site never receives). The values it exposed live here instead,
// typed, so changing the brand or accent is a one-line edit.

export type Theme = "void" | "mist";
export type Density = "cozy" | "comfortable" | "airy";
export type HeadlineKey = "forward" | "applied" | "systems";

export interface SiteConfig {
  brand: string;
  operator: string;
  email: string;
  location: string;
  theme: Theme;
  /** Overrides the --beam accent family when set to something other than the token default. */
  accent: string;
  density: Density;
  headlineKey: HeadlineKey;
}

export const DEFAULT_ACCENT = "#7CA1FF";

export const siteConfig: SiteConfig = {
  brand: "Slimsoft",
  operator: "Slimsoft",
  email: "hello@slimsoft.ai",
  location: "Vancouver, BC",
  theme: "void",
  accent: DEFAULT_ACCENT,
  density: "comfortable",
  headlineKey: "forward",
};
